import React from "react";
import { Chip, Grid } from "@material-ui/core";
import { InvoiceFilter } from "../../../data/accounting/invoices/types";
import { LocalizationContext } from "../../../core/localization/Localization";

export const InvoiceFilterChipsComponent: React.FunctionComponent<InvoiceFilterChipsProps> = ({
  filter,
  removeFilter,
}) => {
  const { getDateString, getString } = React.useContext(LocalizationContext);
  return (
    <Grid container spacing={1}>
      {filter.datefrom && (
        <Grid item>
          <Chip
            label={`${getString("filterFrom")}: ${getDateString(
              new Date(filter.datefrom)
            )}`}
            color="secondary"
            variant="outlined"
            onDelete={() => removeFilter("datefrom")}
          />
        </Grid>
      )}
      {filter.dateto && (
        <Grid item>
          <Chip
            label={`${getString("filterTo")}: ${getDateString(
              new Date(filter.dateto)
            )}`}
            color="secondary"
            variant="outlined"
            onDelete={() => removeFilter("dateto")}
          />
        </Grid>
      )}
      {filter.client && (
        <Grid item>
          <Chip
            label={filter.client.cliName}
            color="secondary"
            variant="outlined"
            onDelete={() => removeFilter("client")}
          />
        </Grid>
      )}
    </Grid>
  );
};

interface InvoiceFilterChipsProps {
  filter: InvoiceFilter;
  removeFilter: (type: keyof InvoiceFilter) => void;
}
